<template>
  <el-dialog title="Enviar mensagem no WhatsApp" v-model="shouldShow">
    <form>
      <base-input label="Título:" v-model="message_.title"> </base-input>
      <base-input
        label="Descrição:"
        hint="Mensagem"
        class="mt-1"
        type="textarea"
        v-model="message_.message"
      >
      </base-input>
      <el-date-picker
        v-model="message_.scheduled_at"
        type="date"
        size="medium"
        placeholder="Agendar envio:"
        :shortcuts="shortcuts"
        format="DD/MM/YYYY"
      >
      </el-date-picker>
    </form>
    <template #footer>
      <el-row justify="space-between" type="flex">
        <el-button type="text" class="button" @click="shouldShow = false"
          >Cancelar</el-button
        >
        <el-button type="text" class="button" @click="createMessage"
          >Enviar</el-button
        >
      </el-row>
    </template>
  </el-dialog>
</template>
<script>
import BaseInput from "../../components/BaseInput.vue";
import { ElNotification } from "element-plus";

export default {
  props: ["contact", "showModal"],
  components: { BaseInput },
  emits: ["close-modal", "should-update"],
  data() {
    return {
      message_: this.category || {},
      isLoadingSave: false,
      systemActions: [],
      shortcuts: [
        {
          text: "Hoje",
          value: new Date(),
        },
        {
          text: "Ontem",
          value: (() => {
            const date = new Date();
            date.setTime(date.getTime() - 3600 * 1000 * 24);
            return date;
          })(),
        },
        {
          text: "Segunda-feira",
          value: (() => {
            const date = new Date();
            date.setTime(
              date.getTime() - 3600 * 1000 * 24 * (date.getDay() - 1)
            );
            return date;
          })(),
        },
        {
          text: "Fim do mês",
          value: (() => {
            return new Date(
              new Date().getFullYear(),
              new Date().getMonth() + 1,
              0
            );
          })(),
        },
        {
          text: "Próxima semana",
          value: (() => {
            const date = new Date();
            date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
            return date;
          })(),
        },
      ],
    };
  },
  watch: {
    event(v) {
      this.message_ = v || {};
    },
  },
  computed: {
    ModalTitle() {
      return !this.isNew ? "Editar Evento" : "Cadastrar Evento";
    },
    DaysToNotificate() {
      const a = [];
      for (let p = 1; p <= 10; p++) {
        a.push({
          label: `${p} dias antes`,
          value: p,
        });
      }

      return a;
    },
    MonthsToRepeat() {
      return [
        {
          label: "Janeiro",
          value: 1,
        },
        {
          label: "Fevereiro",
          value: 2,
        },
        {
          label: "Março",
          value: 3,
        },
        {
          label: "Abril",
          value: 4,
        },
        {
          label: "Maio",
          value: 5,
        },
        {
          label: "Junho",
          value: 6,
        },
        {
          label: "Julho",
          value: 7,
        },
        {
          label: "Agosto",
          value: 8,
        },
        {
          label: "Setembro",
          value: 9,
        },
        {
          label: "Outubro",
          value: 10,
        },
        {
          label: "Novembro",
          value: 11,
        },
        {
          label: "Dezembro",
          value: 12,
        },
      ];
    },
    EventVisibility() {
      return [
        {
          value: "private",
          label: "Privado",
        },
        {
          value: "public",
          label: "Público",
        },
      ];
    },
    EventPriorities() {
      return [
        {
          value: "normal",
          label: "Normal",
        },
        {
          value: "urgent",
          label: "Urgente",
        },
        {
          value: "warning",
          label: "Aviso",
        },
      ];
    },
    shouldShow: {
      get() {
        return this.showModal;
      },
      set() {
        this.$emit("close-modal");
      },
    },
    isNew() {
      return !("uid" in (this.event || {}));
    },
  },
  created() {
    //this.fetchSystemActions();
  },
  methods: {
    createMessage() {
      fetch(`${this.$store.state.apiUrl}whatsapp_messages`, {
        credentials: "include",
        method: "POST",
        body: JSON.stringify({
          ...this.message_,
          contact_id: this.contact?.uid,
        }),
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      })
        .then(async (response) => {
          if (response.status == 200) return await response.json();
          else throw await response.json();
        })
        .then(
          () => {
            ElNotification.success({
              title: `Mensagem enviada com sucesso!`,
              position: "bottom-right",
            });
            this.$emit("close-modal");
          },
          (e) => {
            ElNotification.error({
              title: "Ocorreu um erro ao enviar a mensagem",
              message: Array.isArray(e) ? e[0].message : e.message,
              position: "bottom-right",
            });
          }
        )
        .finally(() => (this.isLoadingSave = false));
    },
  },
  name: "EventModal",
};
</script>
<style>
.el-button {
  max-height: 36px !important;
  margin-top: auto !important;
  margin-bottom: auto !important;
}
.mt-1 {
  margin-top: 4px;
}
</style>